import { useAuth } from '../context/AuthContext';
import { getEffectiveInterval } from '../utils/wateringSchedule';
import type { Plant } from '../types/plant';

/**
 * Compute the effective watering interval for a single plant,
 * using the current user's climate zone and hemisphere.
 * Returns null if no base interval is known.
 */
export function useEffectiveInterval(plant: Plant): number | null {
  const { userDoc } = useAuth();
  return getEffectiveInterval(
    plant,
    userDoc?.climateZone ?? null,
    userDoc?.hemisphere ?? null,
  );
}
